<script>
    export let list;

    export let components;
    export let toggleComponent;
    export let setComponentCount;

    export let openedGroup;


    let preview = ''
    let expandedItem = null; // ID раскрытого элемента

    // Переключение раскрытия элемента
    function toggleExpand(idTovar) {
        expandedItem = expandedItem === idTovar ? null : idTovar;
    }

    // Кастомное действие для выделения текста
    function selectOnMount(node) {
        // Выделяем текст при монтировании элемента

        setTimeout(() => {
            node.select();
        }, 50);
        return {
            destroy() {
                // Очистка при необходимости
            }
        };
    }
</script>

<style>
    div.row .row {
        min-height: 63px;
    }

    div.row-scroller {
        max-height: 350px;
        overflow-y: scroll;
        overflow-x: hidden;
    }

    div.row-scroller::-webkit-scrollbar {
        width: 10px;
    }

    div.row-scroller::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    div.row-scroller::-webkit-scrollbar-thumb {
        background: rgba(108, 124, 148, 0.15);
    }

    div.row-scroller::-webkit-scrollbar-thumb:hover {
        background: #6C7C94;
    }

    .max-height-100 {
        max-height: 100px;
        width: auto;
        margin: auto;
    }

    /* Стили для аккордеона */
    .item-clickable {
        cursor: pointer;
        transition: background-color 0.2s;
    }

    .item-clickable:hover {
        background-color: rgba(0, 0, 0, 0.02);
    }

    .preview-collapse {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease-out;
    }

    .preview-collapse.show {
        max-height: 250px;
        transition: max-height 0.4s ease-in;
    }

    .preview-image {
        width: 100%;
        max-height: 200px;
        object-fit: contain;
        padding: 10px 0;
    }

    .chevron-icon {
        font-size: 12px;
        transition: transform 0.3s;
        display: inline-block;
        margin-left: 8px;
    }

    .chevron-icon.rotated {
        transform: rotate(180deg);
    }
</style>


<div class="row">
    {#each list as [title, group]}
        {#if openedGroup === title}
            <div class="d-none d-lg-block col-12 pb-3">
                 Материалы выбранной категории:
            </div>

            <div class="col-12 row-scroller">
                <div class="row align-items-center position-relative">
                    {#if preview.length}
                        <img class="d-none d-lg-block position-absolute"
                             style="z-index: 9999; top: 0; right: 0; width: 200px; height: 200px; object-fit: cover"
                             src="https://225304.selcdn.ru/axisdb/{ preview }">
                    {/if}

                    {#each group as item}
                        <div class="col-12 col-lg-12 pb-3">
                            <!-- Основная строка - кликабельная только на мобилке -->
                            <div class="row d-flex flex-wrap justify-content-around align-items-center"
                                 class:item-clickable={window.innerWidth < 992}
                                 on:click={() => {
                                     if (window.innerWidth < 992) toggleExpand(item.idTovar);
                                 }}>

                                <div class="col-12  pb-1"
                                     on:mouseenter={() => preview = item.foto_small}
                                     on:mouseleave={() => preview = ''}>
                                    {item.name}
                                    <!-- Шеврон только на мобильных -->
                                    {#if item.foto_small}
                                        <i class="d-lg-none fas fa-chevron-down chevron-icon"
                                           class:rotated={expandedItem === item.idTovar}></i>
                                    {/if}
                                </div>

                                <!-- Раскрывающийся блок с изображением (только на мобилке) -->
                                {#if item.foto_small}
                                    <div class="preview-collapse  "
                                         class:show={expandedItem === item.idTovar}>
                                        <div class="col-12">
                                            <img class="preview-image"
                                                 src="https://225304.selcdn.ru/axisdb/{item.foto_small}"
                                                 alt={item.name}
                                                 loading="lazy" />
                                        </div>
                                    </div>
                                {/if}


                                <div class="col-4 col-lg-2 text-center text-nowrap py-2  ">
                                    {(+item.opt_price).toLocaleString()}₽
                                </div>

                                <div class="col-4 col-lg-1 text-center" on:click|stopPropagation>
                                    <div class="btn-group">
                                        <input type="checkbox" class="btn-check"
                                               bind:checked={components[item.name]}
                                               on:change={(e) => toggleComponent(item.name, e)}
                                               id="tovar-{item.idTovar}">
                                        <label class="btn btn-icon btn-sm btn-outline-primary"
                                               for="tovar-{item.idTovar}">
                                            {#if components.hasOwnProperty(item.name)}
                                                <i class="fas fa-check"></i>
                                            {/if}
                                        </label>
                                    </div>
                                </div>

                                <div class="col-4 col-lg-3 text-center d-flex align-items-center"
                                     on:click|stopPropagation>
                                    {#if components.hasOwnProperty(item.name)}
                                        <input
                                                type="number"
                                                class="form-control text-center me-1"
                                                data-id="{item.idTovar}"
                                                on:keyup={(e) => setComponentCount(item.name, e)}
                                                on:change={(e) => setComponentCount(item.name, e)}
                                                on:focus="{e => e.target.select()}"
                                                bind:value={components[item.name]['count']}
                                                min="1"
                                                style="height: 30px;"
                                                use:selectOnMount
                                        />
                                        {#if item.edIzmer}
                                            <span class="text-nowrap">{item.edIzmer}</span>
                                        {/if}

                                    {/if}


                                </div>


                                {#if (components[item.name]?.count || 0) > 0}
                                    <span class="text-success fw-bold fs-6  col-4 col-lg-3 text-center d-flex align-items-center">
                                        {(+item.opt_price * +(components[item.name]?.count || 0)).toLocaleString()}₽
                                    </span>
                                {/if}

                            </div>


                        </div>
                    {/each}
                </div>
            </div>
        {/if}
    {/each}
</div>

<div style="display: none">
    {#each Object.entries(components) as [item, data]}
        <input type="checkbox" on:change={(e) => toggleComponent(item, e)} data-tovar-title="{item}"/>
        <input type="number" on:change={(e) => setComponentCount(item, e)} data-tovar-count="{item}" value="{data.count}"/>
    {/each}
</div>

